/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  customer.ts
 * @Package :
 * @author:青瞳科技
 * @date:   2022/1/19 11:29
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 青瞳科技
 * 注意：本内容仅限于深圳青瞳科技有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */

const customerRouter = [
    {
        path: '/customerManage',
        name: 'CustomerManage',
        component: () =>
            import(/* webpackChunkName: "customer" */ '@/views/customerManage/Index.vue'),
        meta: {
            title: '客户管理',
            // keepAlive: true,
            deepth: 1,
            permission: true
        },
    },
    {
        path: '/searchCustomer',
        name: 'SearchCustomer',
        component: () =>
            import(/* webpackChunkName: "customer" */ '@/views/customerManage/SearchCustomer.vue'),
        meta: {
            title: '客户查询',
            keepAlive: true,
            deepth: 2
        },
    },
    {
        path: '/customerDetail',
        name: 'CustomerDetail',
        component: () =>
            import(/* webpackChunkName: "customer" */ '@/views/customerManage/CustomerDetail.vue'),
        meta: {
            title: '客户详情',
            // keepAlive: true,
            deepth: 2,
            permission: true
        },
    },
    {
        path: '/customerSetting',
        name: 'CustomerSetting',
        component: () =>
            import(/* webpackChunkName: "customer" */ '@/views/customerManage/CustomerSetting.vue'),
        meta: {
            title: '客户设置',
            keepAlive: true,
            deepth: 3
        },
    },
    {
        path: '/ApplySetting',
        name: 'ApplySetting',
        component: () =>
            import(/* webpackChunkName: "customer" */ '@/views/customerManage/ApplySetting.vue'),
        meta: {
            title: '客户申请通过设置',
            keepAlive: true,
            deepth: 4
        },
    },
    {
        path: '/addCustomer',
        name: 'AddCustomer',
        component: () =>
            import(/* webpackChunkName: "customer" */ '@/views/customerManage/AddCustomer.vue'),
        meta: {
            title: '添加客户',
            keepAlive: true,
            deepth: 2
        },
    },
    {
        path: '/addCustomerNext',
        name: 'AddCustomerNext',
        component: () =>
            import(/* webpackChunkName: "customer" */ '@/views/customerManage/AddCustomerNext.vue'),
        meta: {
            title: '添加客户',
            keepAlive: true,
            deepth: 3
        },
    },
    {
        path: '/valetRegistration',
        name: 'ValetRegistration',
        component: () =>
            import(/* webpackChunkName: "customer" */ '@/views/customerManage/ValetRegistration.vue'),
        meta: {
            title: '代客注册',
            deepth: 3,
            permission: false
        },
    },
    {
        path: '/customerApply',
        name: 'CustomerApply',
        component: () =>
            import(/* webpackChunkName: "customer" */ '@/views/customerManage/CustomerApply.vue'),
        meta: {
            title: '客户申请',
            deepth: 2,
            permission: true
        },
    },
    {
        path: '/customerApplyHandle',
        name: 'CustomerApplyHandle',
        component: () =>
            import(/* webpackChunkName: "customer" */ '@/views/customerManage/CustomerApplyHandle.vue'),
        meta: {
            title: '客户验证',
            deepth: 3
        },
    },
    {
        path: '/levelSetting',
        name: 'LevelSetting',
        component: () =>
            import(/* webpackChunkName: "customer" */ '@/views/customerManage/level/LevelSetting.vue'),
        meta: {
            title: '客户级别设置',
            deepth: 2,
            permission: true
        },
    },
    {
        path: '/levelHandle',
        name: 'LevelHandle',
        component: () =>
            import(/* webpackChunkName: "customer" */ '@/views/customerManage/level/LevelHandle.vue'),
        meta: {
            title: '新增客户级别',
            deepth: 5
        },
    },
    {
        path: '/labelSetting',
        name: 'LabelSetting',
        component: () =>
            import(/* webpackChunkName: "customer" */ '@/views/customerManage/label/LabelSetting.vue'),
        meta: {
            title: '客户标签设置',
            deepth: 2,
            permission: true
        },
    },
    {
        path: '/labelHandle',
        name: 'LabelHandle',
        component: () =>
            import(/* webpackChunkName: "customer" */ '@/views/customerManage/label/LabelHandle.vue'),
        meta: {
            title: '新增客户标签',
            deepth: 5
        },
    },
    {
        path: '/groupSetting',
        name: 'GroupSetting',
        component: () =>
            import(/* webpackChunkName: "customer" */ '@/views/customerManage/group/GroupSetting.vue'),
        meta: {
            title: '客户分组设置',
            deepth: 2,
            permission: true
        },
    },
    {
        path: '/groupHandle',
        name: 'GroupHandle',
        component: () =>
            import(/* webpackChunkName: "customer" */ '@/views/customerManage/group/GroupHandle.vue'),
        meta: {
            title: '新增客户分组',
            deepth: 5
        },
    }
]

export default customerRouter
